// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LanguageItems_wrapper__3ZXLW","item":"LanguageItems_item__7kv9A","link":"LanguageItems_link__3qKyI","opened":"LanguageItems_opened__1ut7L"};